import styled from 'styled-components';
import { Typography } from '@mui/material';

import colors from '../../../styles/colors';

const WeightHistoryContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

const TooltipContainer = styled.div`
  background-color: ${colors.base.alpha};
  padding: 10px;
  border: 1px solid ${colors.shades.gamma1};
  border-radius: 10px;
`;

const Text = styled(Typography)`
  font-size: 13px;
  font-weight: 500;
  color: ${({ $isPositive, $isNegative, $isNeutral }) => {
    if ($isPositive) {
      return colors.base.danger;
    }
    if ($isNegative) {
      return colors.shades.success3;
    }
    if ($isNeutral) {
      return colors.shades.gamma2;
    }
    return colors.base.beta;
  }};
`;

export {
  WeightHistoryContainer,
  TooltipContainer,
  Text,
};
